import EditTransaction from './EditTransaction';

const EditInvestment = () => {
  return <EditTransaction transactionType="investment" returnTo="/investments" isRecurring={false}/>;
};

export default EditInvestment;